const KOMPRA_API_BASE = 'https://kompra.kz/api/v2';
const API_TOKEN = '95cf18f4-1d46-11f1-8de9-0242ac120002';

/**
 * Получить базовые данные контрагента по БИН/ИИН (Kompra.kz API).
 * @param {string} identifier - БИН или ИИН организации/ИП
 * @returns {Promise<Object>} - данные компании
 */
export default async function getCounterpartyBasic(identifier) {
    const trimmed = String(identifier).trim();
    if (!trimmed) {
        throw new Error('Identifier is required');
    }

    const url = `${KOMPRA_API_BASE}/basic?identifier=${encodeURIComponent(trimmed)}&api-token=${API_TOKEN}`;
    const res = await fetch(url);

    if (!res.ok) {
        const text = await res.text();
        let message = `Request failed: ${res.status}`;
        try {
            const json = JSON.parse(text);
            if (json.message) message = json.message;
            else if (json.error) message = json.error;
        } catch (_) {
            if (text) message = text;
        }
        throw new Error(message);
    }

    return res.json();
}
